// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Leaflet.BeautifyIcon, a plugin that adds colorful iconic markers for Leaflet by giving full control of style to end user, It has also ability to adjust font awesome
  and glyphicon icons
  (c) 2016-2017, Muhammad Arslan Sajid
  http://leafletjs.com
*/
.beautify-marker {
    text-align: center;
    font-weight: 700;
    font-family: monospace;
    position:absolute;
    box-sizing: border-box;
}

    .beautify-marker.circle {
        border-radius: 100%;
    }

    .beautify-marker.circle-dot, .beautify-marker.doughnut {
        border-radius: 100%;
    }

    .beautify-marker.marker {
        border-top-left-radius: 50%;
        border-top-right-radius: 50% 100%;
        border-bottom-left-radius: 100% 50%;
        border-bottom-right-radius: 0%;
        /* rotating 45deg clockwise to get the corner bottom center */
        transform: rotate(45deg); 
        
    }

    .beautify-marker.marker > * {
        /* rotating 45deg counterclock to adjust marker content back to normal */
        transform: rotate(-45deg);
    }`, "",{"version":3,"sources":["webpack://./src/BeautifyMarker/leaflet-beautify-marker-icon.css"],"names":[],"mappings":"AAAA;;;;;CAKC;AACD;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IAGjB,sBAAsB;AAC1B;;IAEI;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,2BAA2B;QAC3B,iCAAiC;QACjC,mCAAmC;QACnC,8BAA8B;QAC9B,6DAA6D;QAC7D,wBAAwB;;IAE5B;;IAEA;QACI,wEAAwE;QACxE,yBAAyB;IAC7B","sourcesContent":["/*\n  Leaflet.BeautifyIcon, a plugin that adds colorful iconic markers for Leaflet by giving full control of style to end user, It has also ability to adjust font awesome\n  and glyphicon icons\n  (c) 2016-2017, Muhammad Arslan Sajid\n  http://leafletjs.com\n*/\n.beautify-marker {\n    text-align: center;\n    font-weight: 700;\n    font-family: monospace;\n    position:absolute;\n     -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n}\n\n    .beautify-marker.circle {\n        border-radius: 100%;\n    }\n\n    .beautify-marker.circle-dot, .beautify-marker.doughnut {\n        border-radius: 100%;\n    }\n\n    .beautify-marker.marker {\n        border-top-left-radius: 50%;\n        border-top-right-radius: 50% 100%;\n        border-bottom-left-radius: 100% 50%;\n        border-bottom-right-radius: 0%;\n        /* rotating 45deg clockwise to get the corner bottom center */\n        transform: rotate(45deg); \n        \n    }\n\n    .beautify-marker.marker > * {\n        /* rotating 45deg counterclock to adjust marker content back to normal */\n        transform: rotate(-45deg);\n    }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
